export const jobPostings = [
  // MARK: Heaver Equipment Operator I
  {
    name: "Heavy Equipment Operator I",
    crew: "Construction Crew",
    description:
      "A Heavy Equipment Operator I is responsible for safely and efficiently operating a wheel loader, skid steer, power broom, or off-road dump on a construction site. They use the equipment to move materials like dirt, rocks, gravel, sand, and debris to assist in building infrastructure and utility systems. They adhere to safety regulations, perform routine maintenance on the equipment, and perform manual labor to accomplish project tasks",
    keyResponsibilities: [
      {
        name: "Key Responsibilities",
        responsibilities: [
          {
            title: "Operating the equipment",
            description:
              "Safely and skillfully operate according to manufacture and project requirements, including driving, scooping, lifting, transporting, dumping and grading materials.",
          },
          {
            title: "Pre-shift inspections",
            description:
              "Conducting thorough checks of the equipment before each shift to ensure proper functionality and identify any potential issues.",
          },
          {
            title: "Loading trucks and other vehicles",
            description:
              "Efficiently loads materials onto dump trucks or other transportation vehicles.",
          },
          {
            title: "Driving and dumping",
            description: "Efficiently drives, backs and dumps materials",
          },
          {
            title: "Demo and removal",
            description:
              "Demo and remove material carefully to not disturb/damage items to remain.",
          },
          {
            title: "Safety and site awareness",
            description:
              "Follow all safety protocols and regulations while operating machinery. Signal to other workers and maintain awareness of surroundings.",
          },
          {
            title: "Communication",
            description:
              "Communicate effectively with other construction workers using hand signals, phone or radio to coordinate movements and ensure smooth operations.",
          },
          {
            title: "Reporting issues",
            description:
              "Reporting daily any equipment damage, malfunctions or safety concerns to the supervisor.",
          },
          {
            title: "Crew assistance",
            description: "Perform other crewmember tasks on the jobsite.",
          },
        ],
      },
    ],
    specificOperators: [
      {
        name: "Specific Heavy Operator I Equipment",
        operators: [
          {
            title: "Loader",
            description: "",
          },
          {
            title: "Skid Steer",
            description: "",
          },
          {
            title: "Power Broom",
            description: "",
          },
          {
            title: "Off-Road Dump Truck",
            description: "",
          },
        ],
      },
    ],
    skillsAndQualifications: [
      {
        name: "Skills and Qualifications",
        qualifications: [
          {
            title: "Equipment operation experience",
            description:
              "Prior experience operating assigned equipment or similar machinery.",
          },
          {
            title: "Coordination and stability",
            description:
              "Good hand-eye coordination, dexterity, and the ability to operate levers and controls for extended periods.",
          },
          {
            title: "Physical fitness",
            description:
              "Ability to operate heavy machinery for extended periods, climb ladders and traverse uneven terrain, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks as needed.",
          },
          {
            title: "Mechanical aptitude",
            description:
              "Basic understanding of machine mechanics to troubleshoot, identify, and repair/maintain minor issues.",
          },
          {
            title: "Safety awareness",
            description:
              "Strong commitment to safety procedures and awareness of potential hazards.",
          },
          {
            title: "Communication skills",
            description:
              "Effective communication with other crew members using hand signals and verbal instructions.",
          },
          {
            title: "Valid license or certification",
            description:
              "May require a specific operating license or certification depending on the type of equipment and local regulations.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential Work Environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },
  // MARK: Heavy Equipment Operator II
  {
    name: "Heavy Equipment Operator II",
    crew: "Construction Crew",
    description:
      "A Heavy Equipment Operator II is responsible for safely and efficiently operating large machinery like excavators, bulldozers, graders, and backhoes on construction sites. They use the equipment to move earth, materials, and debris to prepare land, dig and backfill trenches, level surfaces, and assist in building infrastructure and utility systems. They adhere to safety regulations, perform routine maintenance on the equipment, and perform manual labor to accomplish project tasks.",
    keyResponsibilities: [
      {
        name: "Key Responsibilities",
        responsibilities: [
          {
            title: "Operating the equipment",
            description:
              "Safely and skillfully operate according to manufacture and project requirements, including excavating, grading, loading, and transporting materials.",
          },
          {
            title: "Pre-shift inspections",
            description:
              "Conducting thorough checks of the equipment before each shift to ensure proper functionality and identify any potential issues. Includes rigging and connectors.",
          },
          {
            title: "Maintenance and cleaning",
            description:
              "Performing routine maintenance tasks like lubrication, fluid checks, and cleaning.",
          },
          {
            title: "Safety and site awareness",
            description:
              "Follow all safety protocols and regulations while operating machinery. Signal to other workers and maintain awareness of surroundings.",
          },
          {
            title: "Communication",
            description:
              "Communicate effectively with other construction workers using hand signals, phone, or radio to coordinate movements and ensure smooth operations.",
          },
          {
            title: "Reporting issues",
            description:
              "Reporting any equipment malfunctions or safety concerns to the supervisor.",
          },
          {
            title: "Crew assistance",
            description: "Perform other crewmember tasks on the jobsite.",
          },
        ],
      },
    ],
    specificOperators: [
      {
        name: "Specific Heavy Operator II Equipment",
        operators: [
          {
            title: "Excavator operator",
            description: "",
          },
          {
            title: "Bulldozer operator",
            description: "",
          },
          {
            title: "Grader operator",
            description: "",
          },
          {
            title: "Backhoe",
            description: "",
          },
        ],
      },
    ],
    skillsAndQualifications: [
      {
        name: "Skills and Qualifications",
        qualifications: [
          {
            title: "Equipment operation experience",
            description:
              "Prior experience operating assigned equipment or similar machinery.",
          },
          {
            title: "Coordination and stability",
            description:
              "Good hand-eye coordination, dexterity, and the ability to operate levers and controls for extended periods.",
          },
          {
            title: "Physical fitness",
            description:
              "Ability to operate heavy machinery for extended periods, climb ladders and traverse uneven terrain, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks as needed.",
          },
          {
            title: "Mechanical aptitude",
            description:
              "Basic understanding of machine mechanics to troubleshoot, identify, and repair/maintain minor issues.",
          },
          {
            title: "Safety awareness",
            description:
              "Strong commitment to safety procedures and awareness of potential hazards.",
          },
          {
            title: "Communication skills",
            description:
              "Effective communication with other crew members using hand signals and verbal instructions.",
          },
          {
            title: "Valid license or certification",
            description:
              "May require a specific operating license or certification depending on the type of equipment and local regulations.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential Work Environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },
  // MARK: Hillman
  {
    name: "Hillman",
    crew: "Construction Crew",
    description:
      "A construction hill man 'Hillman' is a skilled laborer primarily responsible for assisting a pipe crew in the installing of underground pipe systems, including water mains, sewer lines, and storm drains, performing tasks like preparing pipes, seals and sealants for installation, handling and positioning pipes in trenches, cleaning work areas, and ensuring safe lifting and placement of materials. Tasks often require roadway infrastructure work, manual labor and close collaboration with other crew members to maintain project quality and safety standards.",
    keyResponsibilities: [
      {
        name: "Key Responsibilities",
        responsibilities: [
          {
            title: "Pipe handling",
            description:
              "Carefully lifting and loading, transporting, and positioning pipes to be lowered into the trench to facilitate installation by the pipe layer and tailman.",
          },
          {
            title: "Joint prep and sealing",
            description:
              "Cutting and beveling pipe, confirming and/or applying gasket or other sealant to connect pipe sections.",
          },
          {
            title: "Backfilling",
            description:
              "Filling the trench around the installed pipes with soil and compacting it to provide proper support.",
          },
          {
            title: "Operating equipment",
            description:
              "Utilizing hand tools like shovels, rakes, and power tools like trenchers, compactors, and lifting equipment/rigging as needed.",
          },
          {
            title: "Quality control",
            description:
              "Inspecting pipes, structures and other materials for damage prior to installation.",
          },
          {
            title: "Material management",
            description:
              "Managing and organizing pipes, fittings, and other materials needed for the project.",
          },
          {
            title: "Roadway Infrastructure",
            description:
              "Preparing and completing construction of subgrades, bases, curbing and pavement.",
          },
          {
            title: "Water control",
            description:
              "Installing and maintaining well-point, sump and by-pass systems.",
          },
          {
            title: "Erosion control",
            description:
              "Installing temporary erosion control and final seeding and sodding.",
          },
          {
            title: "Site cleanup",
            description:
              "Removing debris, cleaning up work areas, and disposing of waste materials.",
          },
          {
            title: "Communication",
            description:
              "Collaborating effectively with the pipe crew, foreman, and other workers on site.",
          },
          {
            title: "Safety compliance",
            description:
              "Following safety protocols including wearing appropriate personal protective equipment (PPE) and working in accordance with site safety procedures.",
          },
        ],
      },
    ],
    specificOperators: [],
    skillsAndQualifications: [
      {
        name: "Skills and Qualifications",
        qualifications: [
          {
            title: "Physical fitness",
            description:
              "Physical strength, flexibility and endurance to climb ladders and traverse uneven terrain, kneel or stoop, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks.",
          },
          {
            title: "Mathematical skills",
            description:
              "Measuring and calculating pipe lengths and distances.",
          },
          {
            title: "Equipment and tool operation",
            description:
              "Ability to operate hand and power tools safely and efficiently.",
          },
          {
            title: "Materials",
            description:
              "Knowledge of different pipes, structures, fittings and joining materials.",
          },
          {
            title: "Trenching and Excavation",
            description:
              "Knowledge of trenching and excavation sloping, shielding and shoring methods and techniques.",
          },
          {
            title: "Accuracy",
            description: "Attention to detail and ability to work accurately.",
          },
          {
            title: "Teamwork",
            description:
              "Ability to work as part of a team, serve in different roles and follow instructions.",
          },
          {
            title: "Safety awareness",
            description:
              "Strong commitment to safety procedures and awareness of potential hazards.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential Work Environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },

  // MARK: Pipelayer
  {
    name: "Pipelayer",
    crew: "Construction Crew",
    description:
      "A construction pipe layer ‘Pipelayer” is a skilled tradesperson responsible for installing underground pipe systems, including water mains, sewer lines, and storm drains, by hand digging and leveling trenches, handling and accurately positioning pipes, seating and sealing joints, and backfilling and compacting, ensuring proper alignment and functionality of the pipeline system. Tasks often require roadway infrastructure work, manual labor and close collaboration with other crew members to maintain project quality and safety standards.",
    keyResponsibilities: [
      {
        name: "Key responsibilities",
        responsibilities: [
          {
            title: "Site preparation",
            description:
              "Inspecting the ground, surveying the area, and digging and leveling trenches to the required depth and width to accommodate the pipes.",
          },
          {
            title: "Pipe handling",
            description:
              "Carefully lifting and loading, transporting, and positioning pipes within the trench.",
          },
          {
            title: "Joint prep and sealing",
            description:
              "Confirming gasket or other sealant to connect pipe sections, ensuring proper joint tolerance and seal.",
          },
          {
            title: "Alignment and leveling",
            description:
              "Using electronic and manual surveying tools to ensure pipes are laid at the correct grade and alignment.",
          },
          {
            title: "Backfilling",
            description:
              "Filling the trench around the installed pipes with soil and compacting it to provide proper support.",
          },
          {
            title: "Operating equipment",
            description:
              "Utilizing hand tools like shovels, rakes, and power tools like trenchers, compactors, and lifting equipment/rigging as needed.",
          },
          {
            title: "Quality control",
            description:
              "Inspecting pipes, structures and other materials for damage prior to installation, ensuring joints and connections are properly homed and sealed, adhering to project specifications.",
          },
          {
            title: "Roadway Infrastructure",
            description:
              ": Preparing and completing construction of subgrades, bases, curbing and pavement",
          },
          {
            title: "Water control",
            description:
              "Installing and maintaining well-point, sump and by-pass systems.",
          },
          {
            title: "Erosion Control",
            description:
              "Installing temporary erosion control and final seeding and sodding.",
          },
          {
            title: "Clean up",
            description: "Maintaining a clean and organized work area.",
          },
          {
            title: "Communication",
            description:
              "Collaborating effectively with the pipe crew, foreman, and other workers on site.",
          },
          {
            title: "Safety compliance",
            description:
              "Following safety protocols including wearing appropriate personal protective equipment (PPE) and working in accordance with site safety procedures.",
          },
        ],
      },
    ],
    specificOperators: [{}],
    skillsAndQualifications: [
      {
        name: "Skills and qualifications",
        qualifications: [
          {
            title: "Physical fitness",
            description:
              "Physical strength, flexibility and endurance to climb ladders and traverse uneven terrain, kneel or stoop, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks.",
          },
          {
            title: "Technical skills",
            description:
              "Basic understanding of construction electronic and written blueprints, project plans.",
          },
          {
            title: "Equipment and tool operation",
            description:
              "Ability to operate hand and power tools safely and efficiently.",
          },
          {
            title: "Materials",
            description:
              "Knowledge of different pipes, structure, fittings and joining materials.",
          },
          {
            title: "Trenching and Excavation",
            description:
              "Experience with trenching and excavation sloping, shielding and shoring methods and techniques.",
          },
          {
            title: "Accuracy",
            description: "Attention to detail and ability to work accurately.",
          },
          {
            title: "Teamwork",
            description:
              "Ability to work as part of a team, serve in different roles and follow instructions.",
          },
          {
            title: "Safety awareness",
            description:
              "Strong commitment to safety procedures and awareness of potential hazards.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential work environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },

  // MARK: Superintendent
  {
    name: "Superintendent",
    crew: "Construction",
    description:
      "A construction superintendent is responsible for the day-to-day management and oversight of a construction site(s), ensuring projects are completed on time, within budget, safely and according to construction documents. They coordinate the work of employees and subcontractors, perform quality control checks, enforce and maintain safety standards on site and work closely with project managers to address any issues that arise during construction.",
    keyResponsibilities: [
      {
        name: "Key responsibilities",
        responsibilities: [
          {
            title: "Project execution",
            description:
              "Overseeing all aspects of a construction project, including scheduling, task assignments, and progress monitoring to ensure adherence to timelines.",
          },
          {
            title: "Subcontractor management",
            description:
              "Coordinating the work of various subcontractors, ensuring they meet deadlines and quality and safety standards, and resolving any conflicts between them.",
          },
          {
            title: "Quality control",
            description:
              "Conducting regular inspections to verify that construction work meets project documents, specifications and laws, rules and codes.",
          },
          {
            title: "As-Builts",
            description:
              "Ensure as-built data is collected during construction and submitted in accordance with project requirements.  Follow up on resubmittals as necessary until final acceptance.",
          },
          {
            title: "Safety compliance",
            description:
              "Enforcing safety protocols on site, addressing safety concerns, and ensuring all workers follow proper safety procedures.",
          },
          {
            title: "Site supervision",
            description:
              "Managing construction crews, providing on-site direction, and resolving immediate problems that arise during construction.",
          },
          {
            title: "Communication",
            description:
              "Maintaining clear communication with project managers, subcontractors, and other stakeholders regarding project progress, issues, and updates.",
          },
          {
            title: "Quantity Reporting",
            description:
              "Tracking daily project quantities and identifying potential quantity overruns to stay within budget constraints. Review monthly invoice quantities prior to submission to customer.",
          },
          {
            title: "Problem-solving",
            description:
              "Identifying and addressing challenges that may impact project timelines or quality, implementing solutions to keep the jobsite on track.",
          },
        ],
      },
    ],
    specificOperators: [{}],
    skillsAndQualifications: [
      {
        name: "Skills and qualifications",
        qualifications: [
          {
            title: "Construction experience",
            description:
              "Extensive knowledge of construction means and methods, construction codes, and industry best practices.",
          },
          {
            title: "Project types",
            description: "Residential, Private, and Municipality",
          },
          {
            title: "Utility Construction Scope",
            description: "Water, Sewer, Force Main, Storm, Irrigation",
          },
          {
            title: "Roadway Construction Scope",
            description: "Subgrade, Roadway Base, Asphalt, Curb, Sidewalk",
          },
          {
            title: "Leadership skills",
            description:
              "Ability to manage and motivate a team of workers, including subcontractors.",
          },
          {
            title: "Technical skills",
            description:
              "Understanding of construction electronic and written blueprints, project plans, and scheduling software. Must be able to calculate quantities for asphalt, concrete, and limerock.",
          },
          {
            title: "Safety expertise",
            description:
              "Thorough knowledge of safety regulations and procedures to maintain a safe work environment.",
          },
          {
            title: "Equipment operation experience",
            description:
              "Prior experience operating heavy construction equipment.",
          },
          {
            title: "Vehicle operation experience",
            description:
              "Hold and maintain an acceptable class E drivers license and MVR record.",
          },
          {
            title: "Mechanical aptitude",
            description:
              "Advanced understanding of machine mechanics to identify and troubleshoot minor issues.",
          },
          {
            title: "Physical fitness",
            description:
              "Ability to operate heavy machinery, climb ladders and traverse uneven terrain, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks as needed.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential work environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },

  // MARK: Tailman
  {
    name: "Tailman",
    crew: "Construction",
    description:
      "A construction tail man 'Tailman' is a skilled laborer who primarily assists the pipe layer responsible for installing of underground pipe systems, including water mains, sewer lines, and storm drains, by hand digging and leveling trenches, handling and accurately positioning pipes, seating and sealing joints, and backfilling and compacting, ensuring proper alignment and functionality of the pipeline system. Tasks often require roadway infrastructure work, manual labor and close collaboration with other crew members to maintain project quality and safety standards.",
    keyResponsibilities: [
      {
        name: "Key responsibilities",
        responsibilities: [
          {
            title: "Site preparation",
            description:
              "Digging and leveling trenches to the required depth and width to accommodate the pipes.",
          },
          {
            title: "Pipe handling",
            description:
              "Carefully lifting and loading, transporting, and positioning pipes within the trench to facilitate installation by the pipe layer.",
          },
          {
            title: "Joint prep and sealing",
            description:
              "Confirming and/or applying gasket or other sealant to connect pipe sections, ensuring proper joint tolerance and seal.",
          },
          {
            title: "Alignment and grading",
            description:
              "Using electronic and manual surveying tools to ensure pipes are laid at the correct grade and alignment.",
          },
          {
            title: "Backfilling",
            description:
              "Filling the trench around the installed pipes with soil and compacting it to provide proper support.",
          },
          {
            title: "Operating equipment",
            description:
              "Utilizing hand tools like shovels, rakes, and power tools like trenchers, compactors, and lifting equipment/rigging as needed.",
          },
          {
            title: "Quality control",
            description:
              "Inspecting pipes, structures and other materials for damage prior to installation, ensuring joints and connections are properly homed and sealed, adhering to project specifications.",
          },
          {
            title: "Roadway Infrastructure",
            description:
              "Preparing and completing construction of subgrades, bases, curbing and pavement.",
          },
          {
            title: "Water control",
            description:
              "Installing and maintaining well-point, sump and by-pass systems.",
          },
          {
            title: "Erosion Control",
            description:
              "Installing temporary erosion control and final seeding and sodding.",
          },
          {
            title: "Clean up",
            description:
              "Maintaining a clean and organized work area within the trench.",
          },
          {
            title: "Communication",
            description:
              "Collaborating effectively with the pipe crew, foreman, and other workers on site.",
          },
          {
            title: "Safety compliance",
            description:
              "Following safety protocols including wearing appropriate personal protective equipment (PPE) and working in accordance with site safety procedures.",
          },
        ],
      },
    ],
    specificOperators: [{}],
    skillsAndQualifications: [
      {
        name: "Skills and qualifications",
        qualifications: [
          {
            title: "Physical fitness",
            description:
              "Physical strength, flexibility and endurance to climb ladders and traverse uneven terrain, kneel or stoop, lift and carry 50lbs, work in adverse weather conditions and perform manual tasks.",
          },
          {
            title: "Mathematical skills",
            description:
              "Measuring and calculating pipe lengths and distances.",
          },
          {
            title: "Equipment and tool operation",
            description:
              "Ability to operate hand and power tools safely and efficiently.",
          },
          {
            title: "Materials",
            description:
              "Knowledge of different pipes, structures, fittings and joining materials.",
          },
          {
            title: "Trenching and Excavation",
            description:
              "Knowledge of trenching and excavation sloping, shielding and shoring methods and techniques.",
          },
          {
            title: "Accuracy",
            description: "Attention to detail and ability to work accurately.",
          },
          {
            title: "Teamwork",
            description:
              "Ability to work as part of a team, serve in different roles and follow instructions.",
          },
          {
            title: "Safety awareness",
            description:
              "Strong commitment to safety procedures and awareness of potential hazards.",
          },
        ],
      },
    ],
    potentialWorkEnvironments: [
      {
        name: "Potential work environments",
        environments: [
          {
            description:
              "Outside- Extreme weather conditions, sun exposure, heat stress, cold, wind, rain, dust, insects and animal bites and other environmental factors according to location.",
          },
        ],
      },
    ],
  },
  // MARK: CDL Driver
  // {
  //   name: "CDL Driver Class A or B",
  //   crew: "Driver",
  //   description: "",
  // },
];

// {
//     name: "",
//     crew: "",
//     description:
//         ""
//     keyResponsibilities: [
//       {
//         name: "Key responsibilities",
//         responsibilities: [
//           {
//             title: "",
//             description:
//               "",
//           },
//         ],
//       },
//     ],
//     specificOperators: [
//       {
//         name: "",
//         operators: [
//           {
//             title: "",
//             description:
//               "",
//           },
//         ],
//       },
//     ],
//     skillsAndQualifications: [
//       {
//         name: "Skills and qualifications",
//         qualifications: [
//           {
//             title: "",
//             description:
//               "",
//           },
//         ],
//       },
//     ],
//     potentialWorkEnvironments: [
//       {
//         name: "Potential work environments",
//         environments: [
//           {
//             description: ""
//         },
//         ],
//       },
//     ],
//   },
